export default __webpack_public_path__ + "static/media/artist-statement.ff3c6bae.jpg";